// extracted by mini-css-extract-plugin
export default {"p1":"SeverityChip_p1__+V6wW","p2":"SeverityChip_p2__EH2fk","p3":"SeverityChip_p3__iXfBh","p4":"SeverityChip_p4__XNH8c","unknown":"SeverityChip_unknown__JW1YH"};